// extracted by mini-css-extract-plugin
export default {"details":"EeWg23plFqZbw5xEQTGg","label":"gle0AZ_G3ojn5rlZu7ri","redRow":"uFOHwasTYBsg4SDvlmw5","testClass":"NbTnwxXBHFDtoNs26IxK"};